import { onError } from '@apollo/client/link/error';
import { Observable } from '@apollo/client';
import Session from 'supertokens-auth-react/recipe/session';
import Debug from 'debug';
const debug = Debug('APOLLO.RefreshOnTokenExpiredLink');
// debug.enabled = true;

/**
 * Error handler de apollo, para intentar refrescar la sessión si el error fue TOKEN_EXPIRED
 */
export function buildRefreshOnTokenExpiredLink() {
    return onError(({ graphQLErrors, operation, forward }) => {
        debug('ocurrió un error graphql');
        const tokenExpiredError = graphQLErrors?.some(
            (error) => error.extensions?.code === 'TOKEN_EXPIRED'
        );

        if (!tokenExpiredError) {
            debug('pero no es TOKEN_EXPIRED, saliendo');
            return;
        }

        return new Observable((observer) => {
            debug('intentamos refrescar la sessión');
            Session.attemptRefreshingSession()
                .then((refreshed) => {
                    debug('terminó de refrescar y ', { refreshed });
                    if (!refreshed) {
                        debug('no se pudo refrescar, tiramos error');
                        observer.error(new Error('Session refresh failed'));
                        return;
                    }

                    debug('refrescó ok, continuamos');
                    forward(operation).subscribe(observer);
                })
                .catch((error) => {
                    debug(
                        `ocurrió un error: ${JSON.stringify(error, null, 2)}`,
                        error
                    );
                    observer.error(error);
                });
        });
    });
}
